module.exports = __webpack_public_path__ + "img/_dimensions.cb93688b.png";